import createNamespaceContext from './helper/createNamespaceContext';
export var POST_OFFICE_CONTEXT = 'postOfficeCtx';
export var PostOfficeAnalyticsContext = createNamespaceContext(POST_OFFICE_CONTEXT, 'PostOfficeAnalyticsContext');